interface UrlInfo {
  path: string;
  build: (...args: any[]) => string;
  label: string;
}

// satisfies — 없는 키(Urls.xxx)를 쓰면 tsc가 잡도록 키를 리터럴로 유지한다
export const Urls = {
  main: {
    path: '/',
    build: () => '/',
    label: '통합검색',
  },
  search: {
    path: '/search',
    build: (query?: string) =>
      query ? `/search?q=${encodeURIComponent(query)}` : '/search',
    label: '검색 결과',
  },
  archive: {
    path: '/archive/:rootFolderId/*',
    // 인자 없이 부르면 폴더 미지정 진입(/archive) — 첫 top 폴더로 리다이렉트된다
    build: (folderIdPath: string = '') => `/archive${folderIdPath}`,
    label: '폴더 탐색',
  },
  dump: {
    path: '/dump',
    build: () => '/dump',
    label: '휴지통',
  },
  cart: {
    path: '/cart',
    build: () => '/cart',
    label: '담은 자료',
  },
  settingsMetadata: {
    path: '/settings/metadata',
    build: () => '/settings/metadata',
    label: '메타데이터 설정',
  },
} as const satisfies Record<string, UrlInfo>;

export type URL_KEY = keyof typeof Urls;
export type URL_VAL = (typeof Urls)[URL_KEY];
